import { deleteApi, getApi, putApi } from "../../../../../utils/api.ts";
import {
  API_EMPLOYEE_TECH_STACK,
  API_EMPLOYEE_TECH_STACK_MASTER,
} from "../../../../../../config/Endpoints.js";
import {
  employeeTechStackResponseSchema,
  techStackMasterSchema,
} from "../schemas.ts";
import type {
  EmployeeTechStackResponse,
  TechStackCategory,
  UpdateEmployeeTechStackRequest,
} from "../types.ts";

function unwrapApiData(value: unknown): unknown {
  if (
    value != null &&
    typeof value === "object" &&
    "data" in value
  ) {
    return (value as { data: unknown }).data;
  }
  return value;
}

export async function fetchTechStackMaster(
  accessToken?: string,
  signal?: AbortSignal,
): Promise<TechStackCategory[]> {
  const response = await getApi<unknown>(
    API_EMPLOYEE_TECH_STACK_MASTER,
    accessToken,
    "json",
    signal,
  );
  return techStackMasterSchema.parse(unwrapApiData(response.data));
}

export async function fetchEmployeeTechStacks(
  accessToken?: string,
  signal?: AbortSignal,
): Promise<EmployeeTechStackResponse> {
  const response = await getApi<unknown>(
    API_EMPLOYEE_TECH_STACK,
    accessToken,
    "json",
    signal,
  );
  return employeeTechStackResponseSchema.parse(
    unwrapApiData(response.data),
  );
}

export async function saveEmployeeTechStacks(
  request: UpdateEmployeeTechStackRequest,
  accessToken?: string,
): Promise<void> {
  await putApi(
    API_EMPLOYEE_TECH_STACK,
    accessToken,
    { techStacks: request.techStacks },
  );
}

export async function deleteEmployeeTechStack(
  employeeId: number,
  techStackId: number,
  accessToken?: string,
): Promise<void> {
  await deleteApi(
    `${API_EMPLOYEE_TECH_STACK}/${encodeURIComponent(
      String(employeeId),
    )}/${encodeURIComponent(String(techStackId))}`,
    accessToken,
  );
}
